import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import NoRecord from "../../components/NoDataScreen/NoRecord";
import { useLoader } from "../../components/loader/loader";
import { ApiUrl } from "../../config/apiConfig";
import { PaginationControls } from "../../models/pagination";
import { getData } from "../../services/Axios/Axios";
import pluseicon from "./../../assets/img/close-circle.svg";

interface AddPickupInformationProps {
  isOpens: boolean;
  closeModal: () => void;
  singleUser: any;
}

const UserData = React.forwardRef((props: AddPickupInformationProps, ref) => {
  const { isOpens, closeModal, singleUser } = props;

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      background: "unset !important",
      padding: "0 !important",
      border: "none !important",
      width: "100%",
      maxHeight: "100vh",
      overflowY: "auto" as const,
    },
  };

  const [pagination, setPagination] = useState(new PaginationControls());
  const { show, hide } = useLoader();
  const [startIndex, setStartIndex] = useState(0);
  const [allData, setAllData] = useState([]);

  console.log(singleUser, "8765456789kjhgfg");

  const roleMapping: Record<string, string> = {
    Admin: "Admin",
    Partner_admin: "Partner Admin",
    Operation_manager: "Operation Manager",
    Office_admin: "Office Admin",
    Dispatcher: "Dispatcher",
    Biller: "Biller",
    Sales_agent: "Sales Agent",
    Data_entry: "Data Entry",
    Safety: "Safety",
  };

  useEffect(() => {
    if (singleUser) {
      getDataALL(singleUser);
    }
  }, [pagination.page, singleUser]);

  const getDataALL = async (data?: any) => {
    const skip = (pagination.page - 1) * pagination.limit;
    const requestData = { skip_number: skip, _id: data };

    try {
      const response = await getData(ApiUrl.listCompanies, requestData, {
        show,
        hide,
      });
      if (response) {
        setAllData(response.data[0].userId);
      } else {
        setAllData([]);
      }
      setPagination((prevPagination) => ({
        ...prevPagination,
        count: response.total_count || 0,
      }));
      setStartIndex(skip + 1);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  console.log(allData, "4567890");

  return (
    <Modal isOpen={isOpens} style={customStyles} contentLabel="Add User Modal">
      <div id="newrole" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-xl my-4">
          <div className="modal-content customizeloadlist p-0">
            <div className="modalheader driverdetail px-4">
              <h2 className="modaltitle m-0">Company User Details</h2>
              <img
                src={pluseicon}
                alt="Close"
                onClick={closeModal}
                className="close-icon"
              />
            </div>
            <div className="modalbody1">
              <div className="p-4">
                <div className="grid16px">
                  <div className="tablinkgrid">
                    <div className="tablebox tablinkgrid bortr">
                      <div className="tablebox12">
                        <div className="scrollbar-box detail-scroll">
                          <table className="load-table w-100">
                            <thead>
                              <tr className="load-list-head btlr">
                                <th className="load-list-th btl">S.No</th>
                                <th className="load-list-th">User Name</th>
                                <th className="load-list-th">Role</th>
                                <th className="load-list-th">Phone Number</th>
                                <th className="load-list-th">Email Address</th>
                                <th className="load-list-th">Office Address</th>
                              </tr>
                            </thead>
                            <tbody>
                              {allData.length > 0 ? (
                                allData.map((data: any, index: number) => (
                                  <tr className="load-list-body" key={index}>
                                    <td className="load-list-td">
                                      {startIndex + index}
                                    </td>
                                    <td className="load-list-td">
                                      {index === 0
                                        ? `${data?.first_name || ""} ${
                                            data?.last_name || ""
                                          }`.trim() || "-"
                                        : data?.fullName || "-"}
                                    </td>
                                    <td className="load-list-td">
                                      {index === 0
                                        ? "Owner"
                                        : roleMapping[data.role] || "-"}
                                    </td>
                                    <td className="load-list-td">
                                      {index === 0
                                        ? data?.phone_number &&
                                          `(${data?.phone_number.slice(
                                            0,
                                            3
                                          )}) ${data?.phone_number.slice(
                                            3,
                                            6
                                          )}-${data?.phone_number.slice(6, 10)}`
                                        : (data?.phoneNumber &&
                                            `(${data?.phoneNumber.slice(
                                              0,
                                              3
                                            )}) ${data?.phoneNumber.slice(
                                              3,
                                              6
                                            )}-${data?.phoneNumber.slice(
                                              6,
                                              10
                                            )}`) ||
                                          "-"}
                                    </td>
                                    <td className="load-list-td">
                                      {data?.email || "-"}
                                    </td>
                                    <td className="load-list-td">
                                      {data?.office_address || "-"}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan={7}>
                                    <NoRecord noDataText="No data available in Users" />
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="text-end"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ddfffd */}
    </Modal>
  );
});

export default UserData;
